export default __webpack_public_path__ + "static/media/week.33ae220d.jpeg";